import { combineReducers, createStore } from "redux"
import Authentication from './store/Authentication'

const reducer = combineReducers({
  Authentication
})

export default createStore(reducer)